const SITE_URL = (process.env.VUE_APP_SITE_URL || "https://www.usoonivf.com").replace(
  /\/$/,
  ""
);
const SITE_NAME = "佑昇生殖中心";
const DEFAULT_IMAGE = `${SITE_URL}/banner1.jpg`;
const DEFAULT_DESCRIPTION =
  "佑昇生殖中心位於台北市中山區，提供不孕症檢查、人工授孕、試管嬰兒、凍卵與生殖醫學諮詢，並提供門診資訊及線上預約。";
const BACKEND_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL || "/api";
let activeRoute = null;

const ROUTE_SEO = {
  Index: {
    title: "佑昇生殖中心｜試管嬰兒、不孕症治療與凍卵諮詢",
    description: DEFAULT_DESCRIPTION,
    label: "首頁",
  },
  KnowUSoon: {
    title: "認識佑昇｜佑昇生殖中心",
    description:
      "認識佑昇生殖中心的生殖醫療團隊、診療理念、實驗室設備與個人化友善醫療服務。",
    label: "認識佑昇",
    path: "/knowusoon",
  },
  HowToReserve: {
    title: "掛號方式｜佑昇生殖中心",
    description: "查看佑昇生殖中心的掛號方式、預約流程與行動 App 資訊。",
    label: "掛號方式",
    path: "/how-to-reserve",
  },
  Reserve: {
    title: "線上預約掛號｜佑昇生殖中心",
    description: "查詢佑昇生殖中心門診班表，選擇日期、診別與醫師後進行線上預約掛號。",
    label: "預約掛號",
    path: "/reserve",
  },
  ReserveCheck: {
    title: "預約掛號查詢｜佑昇生殖中心",
    description: "查詢或取消已建立的佑昇生殖中心門診預約。",
    label: "預約查詢",
    path: "/reserve-check",
    noindex: true,
  },
  Service: {
    title: "不孕症與生殖療程服務｜佑昇生殖中心",
    description:
      "佑昇生殖中心提供不孕症檢查、人工授孕、試管嬰兒、凍卵、精液檢查與著床前遺傳診斷等諮詢。",
    label: "診療項目",
    path: "/service",
    schemaType: "Service",
  },
  Doctor: {
    title: "醫療團隊｜佑昇生殖中心",
    description: "查看佑昇生殖中心醫師的學經歷、專長與門診時段。",
    label: "醫療團隊",
  },
  News: {
    title: "生殖新知｜佑昇生殖中心",
    description: "閱讀不孕症、試管嬰兒、生殖醫學與備孕相關的醫療新知。",
    label: "生殖新知",
    path: "/news",
  },
  NewsInfo: {
    title: "生殖新知｜佑昇生殖中心",
    description: "佑昇生殖中心提供的生殖醫學、試管嬰兒與備孕相關資訊。",
    label: "生殖新知",
  },
  HeartRoad: {
    title: "療程心路歷程｜佑昇生殖中心",
    description: "閱讀佑昇生殖中心分享的備孕、生殖療程與心路歷程。",
    label: "心路歷程",
    path: "/heart-road",
  },
  ContactUs: {
    title: "聯絡與門診資訊｜佑昇生殖中心",
    description:
      "佑昇生殖中心位於台北市中山區長安東路二段88號8樓，查看聯絡電話、交通方式與門診時間。",
    label: "聯絡我們",
    path: "/contact-us",
  },
  WeCare: {
    title: "關懷資訊｜佑昇生殖中心",
    description: DEFAULT_DESCRIPTION,
    label: "關懷資訊",
    path: "/we-care",
  },
  BackStage: {
    title: "網站管理後台｜佑昇生殖中心",
    description: "佑昇生殖中心網站管理後台。",
    label: "網站管理後台",
    noindex: true,
    path: "/backstage",
  },
  DocGroup: { noindex: true },
  Banners: { noindex: true },
  Articles: { noindex: true },
  NotFound: {
    title: "找不到頁面｜佑昇生殖中心",
    description: "這個頁面不存在，請回到佑昇生殖中心首頁瀏覽診療與預約資訊。",
    noindex: true,
  },
};

const upsertMeta = (attribute, key, content) => {
  if (!content) return;
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const removeMeta = (attribute, key) => {
  const element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (element) element.remove();
};

const absoluteUrl = (value) => {
  if (!value) return DEFAULT_IMAGE;
  try {
    const url = new URL(value, `${SITE_URL}/`);
    return ["http:", "https:"].includes(url.protocol)
      ? url.toString()
      : DEFAULT_IMAGE;
  } catch (error) {
    return DEFAULT_IMAGE;
  }
};

// Uploaded images use the same API location as their visible page images.
const backendImageUrl = (value) => {
  if (!value) return DEFAULT_IMAGE;
  return absoluteUrl(
    /^(https?:|data:|blob:|\/\/)/i.test(value)
      ? value
      : `${BACKEND_BASE_URL}${value}`
  );
};

const normalizedPath = (path) => {
  const value = String(path || "/").split(/[?#]/)[0] || "/";
  return value === "/" ? "/" : value.replace(/\/$/, "");
};

const cleanDescription = (value, fallback = DEFAULT_DESCRIPTION) => {
  const text = String(value || fallback)
    .replace(/\s+/g, " ")
    .trim();
  return text.length > 160 ? `${text.slice(0, 157)}…` : text;
};

const setCanonical = (path) => {
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  const url = `${SITE_URL}${normalizedPath(path)}`;
  canonical.setAttribute("href", url);
  return url;
};

const setPageStructuredData = (data) => {
  const id = "page-structured-data";
  let element = document.getElementById(id);
  if (!data) {
    if (element) element.remove();
    return;
  }
  if (!element) {
    element = document.createElement("script");
    element.id = id;
    element.type = "application/ld+json";
    document.head.appendChild(element);
  }
  element.textContent = JSON.stringify(data);
};

const breadcrumbSchema = (path, label) => ({
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "首頁",
      item: `${SITE_URL}/`,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: label,
      item: `${SITE_URL}${normalizedPath(path)}`,
    },
  ],
});

export const applySeo = ({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  structuredData = null,
  publishedTime = "",
  modifiedTime = "",
  author = "",
}) => {
  const finalTitle = title || SITE_NAME;
  const finalDescription = cleanDescription(description);
  const canonicalUrl = setCanonical(path);
  const finalImage = absoluteUrl(image);

  document.title = finalTitle;
  upsertMeta("name", "description", finalDescription);
  upsertMeta(
    "name",
    "robots",
    noindex ? "noindex,nofollow,noarchive" : "index,follow,max-image-preview:large"
  );
  upsertMeta("property", "og:locale", "zh_TW");
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:site_name", SITE_NAME);
  upsertMeta("property", "og:title", finalTitle);
  upsertMeta("property", "og:description", finalDescription);
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:image", finalImage);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", finalTitle);
  upsertMeta("name", "twitter:description", finalDescription);
  upsertMeta("name", "twitter:image", finalImage);
  if (publishedTime) upsertMeta("property", "article:published_time", publishedTime);
  else removeMeta("property", "article:published_time");
  if (modifiedTime) upsertMeta("property", "article:modified_time", modifiedTime);
  else removeMeta("property", "article:modified_time");
  if (author) upsertMeta("name", "author", author);
  else removeMeta("name", "author");
  setPageStructuredData(structuredData);
};

export const applyRouteSeo = (route, overrides = {}) => {
  const previousRoute = activeRoute;
  activeRoute = route || null;
  // Query/hash-only navigation does not reload a detail component's content.
  // Retain its resolved title and Article/Person data until the identifier changes.
  if (
    route &&
    previousRoute &&
    ["NewsInfo", "Doctor"].includes(route.name) &&
    route.name === previousRoute.name &&
    route.params &&
    previousRoute.params &&
    String(route.params.uid) === String(previousRoute.params.uid) &&
    Object.keys(overrides).length === 0
  ) return;
  const config = {
    ...(ROUTE_SEO[route && route.name] || {}),
    ...overrides,
  };
  const detailPrefix = { NewsInfo: "/news", Doctor: "/doctor" }[
    route && route.name
  ];
  const detailPath =
    detailPrefix && route.params && route.params.uid != null
      ? `${detailPrefix}/${encodeURIComponent(route.params.uid)}`
      : null;
  const path = normalizedPath(
    config.path || detailPath || (route && route.path) || "/"
  );
  const noindex = Boolean(
    config.noindex ||
      /^\/backstage(?:\/|$)/i.test(path) ||
      !ROUTE_SEO[route && route.name]
  );
  const graph = [];

  if (path !== "/" && !noindex) {
    graph.push(breadcrumbSchema(path, config.label || SITE_NAME));
  }
  if (config.schemaType === "Service") {
    graph.push({
      "@type": "Service",
      name: "生殖醫學與不孕症診療服務",
      provider: { "@id": `${SITE_URL}/#clinic` },
      areaServed: { "@type": "Country", name: "Taiwan" },
      url: `${SITE_URL}${path}`,
    });
  }

  applySeo({
    title: config.title,
    description: config.description,
    path,
    noindex,
    structuredData: graph.length
      ? { "@context": "https://schema.org", "@graph": graph }
      : null,
  });
};

export const applyArticleSeo = (article) => {
  // A slow response from a page already left must not overwrite the new page.
  if (
    !article ||
    !activeRoute ||
    activeRoute.name !== "NewsInfo" ||
    String(activeRoute.params && activeRoute.params.uid) !== String(article.uid)
  ) return;
  const path = `/news/${encodeURIComponent(article.uid)}`;
  const description = cleanDescription(article.summary || article.content);
  const image = backendImageUrl(article.img_url);
  const authorName = String(article.author_name || "").trim();
  const modifiedTime = article.updated_at || "";
  const articleSchema = {
    "@type": "Article",
    headline: article.title,
    description,
    image: [absoluteUrl(image)],
    mainEntityOfPage: `${SITE_URL}${path}`,
    publisher: { "@id": `${SITE_URL}/#clinic` },
  };
  if (article.post_date) articleSchema.datePublished = article.post_date;
  if (modifiedTime) articleSchema.dateModified = modifiedTime;
  if (authorName) {
    articleSchema.author = {
      "@type": /佑昇|團隊|中心|診所/.test(authorName) ? "Organization" : "Person",
      name: authorName,
    };
  }
  applySeo({
    title: `${article.title}｜${SITE_NAME}`,
    description,
    path,
    image,
    type: "article",
    publishedTime: article.post_date,
    modifiedTime,
    author: authorName,
    structuredData: {
      "@context": "https://schema.org",
      "@graph": [articleSchema, breadcrumbSchema(path, article.title)],
    },
  });
};

export const applyDoctorSeo = (doctor) => {
  const doctorSn = doctor && (doctor.DocBaseSn || doctor.docBaseSn);
  const doctorName = doctor && (doctor.DocName || doctor.docName);
  const filePath = doctor && (doctor.FilePath || doctor.filePath);
  if (!doctorSn || !doctorName) return;
  if (
    !activeRoute ||
    activeRoute.name !== "Doctor" ||
    String(activeRoute.params && activeRoute.params.uid) !== String(doctorSn)
  ) return;
  const path = `/doctor/${encodeURIComponent(doctorSn)}`;
  const image = backendImageUrl(filePath);
  applySeo({
    title: `${doctorName} 醫師｜${SITE_NAME}`,
    description: `查看${SITE_NAME}${doctorName} 醫師的學經歷、專長與門診時段。`,
    path,
    image,
    structuredData: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Person",
          name: doctorName,
          jobTitle: "醫師",
          image,
          url: `${SITE_URL}${path}`,
          worksFor: { "@id": `${SITE_URL}/#clinic` },
        },
        breadcrumbSchema(path, `${doctorName} 醫師`),
      ],
    },
  });
};
